import { connect } from 'react-redux'
import BookingPlugin from '../../components/booking-plugin'

const mapStateToProps = state => ({...state.bookingPlugin})

const mapDispatchToProps = dispatch => ({
  selectSize: payload => dispatch({type: 'BOOKING_PLUGIN.SELECT_SIZE', payload}),
  selectDate: payload => dispatch({type: 'BOOKING_PLUGIN.SELECT_DATE', payload}),
  selectDuration: payload => dispatch({type: 'BOOKING_PLUGIN.SELECT_DURATION', payload}),
  selectInterval: payload => dispatch({type: 'BOOKING_PLUGIN.SELECT_INTERVAL', payload}),
  setStep: payload => dispatch({type: 'BOOKING_PLUGIN.SET_STEP', payload}),
  fetchIntervals: payload => dispatch({type: 'BOOKING_PLUGIN.FETCH_INTERVALS', payload}),
  fetchPrice: payload => dispatch({type: 'BOOKING_PLUGIN.FETCH_PRICE', payload}),
  verifyPerson: payload => dispatch({type: 'BOOKING_PLUGIN.VERIFY_PERSON', payload}),
  setPerson: payload => dispatch({type: 'BOOKING_PLUGIN.SET_PERSON', payload}),
  confirmCode: payload => dispatch({type: 'BOOKING_PLUGIN.CONFIRM_CODE', payload}),
  resendCode: payload => dispatch({type: 'BOOKING_PLUGIN.RESEND_CODE', payload}),
  bookField: payload => dispatch({type: 'BOOKING_PLUGIN.BOOK_FIELD', payload}),
  setLoading: payload => dispatch({type: 'BOOKING_PLUGIN.SET_LOADING', payload}),
  setAlert: (payload) => dispatch({type: 'BOOKING_PLUGIN.SET_ALERT', payload}),
  bookMore: (payload) => dispatch({type: 'BOOKING_PLUGIN.BOOK_MORE', payload}),
})

export default connect(mapStateToProps, mapDispatchToProps)(BookingPlugin)
